<h2 mat-dialog-title>Link invoice</h2>

<div mat-dialog-content>
  <div class="m-b-2">
    <input
      class="form-control"
      type="text"
      [(ngModel)]="existingInvoiceSearch"
      (input)="applyExistingInvoiceFilter()"
      placeholder="Zoek op factuurnummer, titel, status..."
    />
  </div>

  <div *ngIf="isLoading" class="m-b-2">Facturen laden...</div>

  <div *ngIf="!isLoading">
    <label class="m-b-1 d-block">Bestaande factuur</label>
    <select class="form-control" [(ngModel)]="selectedExistingInvoiceNumber">
      <option [ngValue]="''" disabled>-- Kies een factuur --</option>
      <option *ngFor="let invoice of filteredComanageInvoices" [ngValue]="getComanageInvoiceNumber(invoice)">
        {{ getComanageInvoiceDisplay(invoice) }}
      </option>
    </select>

    <small class="d-block m-t-1" *ngIf="filteredComanageInvoices.length === 0">
      Geen facturen gevonden.
    </small>
  </div>
</div>

<div mat-dialog-actions class="link-invoice-actions">
  <button mat-stroked-button class="btn-close" (click)="closeDialog()">Sluiten</button>
  <button mat-flat-button color="primary" class="btn-link" (click)="linkInvoice()" [disabled]="isLoading || !selectedExistingInvoiceNumber">Koppel</button>
</div>
